export default function Timeline({ children }) {
  return <div className="Timeline">{children}</div>;
}
